<template>
  <history-plate v-if="plate" :record="client" :clientId="clientId" />
  <history v-else :clientId="clientId" />
</template>

<script>
import History from '@/components/History.vue'
import HistoryPlate from '@/components/HistoryPlate.vue'

export default {
  components: { History, HistoryPlate },
  props: {
    // The client page's new look (Seaded -> Kliendid uues kujunduses).
    plate: {
      type: Boolean,
      default: false
    },
    overview: {
      type: Object,
      default: null
    },
    client: {
      type: Object,
      default: () => ({})
    },
    clientId: {
      required: true
    }
  }
}
</script>
